import LookUpModel from "stores/lookup/models/LookUpModel";

export default class ComuniModel extends LookUpModel {
    public readonly key: string = "";
    public readonly value: string = "";
    public readonly postalCode: string = "";
    public readonly countyCode: string = "";
    public readonly countyName: string = "";

    constructor(data: Partial<ComuniModel>) {
        super(data);

        this.update(data);
    }
}
